/**
 * What a badge's add came back with. A refusal carries the line to show when the
 * server said why — a study set whose question is no longer scheduled is a badge
 * that went stale, not a request to retry — and falls back to the block's own
 * generic line when it did not.
 */
export type QuestionBadgeAddResult =
  | {
      ok: true;
      /**
       * The block was already in the thread — this mount had made it — so the
       * request went nowhere and the thread scrolled to what is already there.
       * The control that asked says so rather than looking like it did nothing
       * with the curation the student just changed (ORA-832).
       */
      alreadyAdded?: boolean;
    }
  | {
      ok: false;
      message?: string;
      /**
       * The content behind the badge is gone for good rather than refused for
       * now, so the action that asked for it is withdrawn instead of inviting
       * a tap that can only fail again.
       */
      contentGone?: boolean;
      /**
       * What the badge was offering is not what the server schedules any more,
       * so the cached variant is dropped and read again — the preview was of the
       * wrong question, and a second tap on the same one could only fail again.
       */
      staleVariant?: boolean;
    };

/** Which badge a request is in flight for; only one runs at a time. */
export type PendingBadge = 'flashcards' | 'scheduled_variant';

export const BADGE_ADD_FAILED =
  'That could not be added to the chat. Try again.';
